const motivoCancelacionInitialState = {
  motivoCancelacion: {
    loading: false,
    error: null,
    turnos: null,
    laboratorio: null,
  },
};

export default motivoCancelacionInitialState;
